/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `EMAIL` - Email
 * * `PHONE` - Phone
 */
export type LoginMethodEnum = typeof LoginMethodEnum[keyof typeof LoginMethodEnum];


export const LoginMethodEnum = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
} as const;
